export default {
	state: {
		"alert": {}
	},
	mutations: {

	}
}
